import React, { useMemo, useState } from "react";
import Section from "../Section";
import { ApartmentsTypes } from "../../Data/ApartmentsTypes";
import { delayNavigation } from "../../helpers/helpers";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { greenHomeOutterRenderPaths } from "../../assest/imgPaths";

const ApartmentsSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState(
    ApartmentsTypes.greenhome.apartmentsArray[0].name
  );
  const selectedTypeObj = useMemo(() => {
    const current = ApartmentsTypes.greenhome.apartmentsArray.find(
      (item) => item.name === selectedType
    );
    return current;
  }, [selectedType]);
  return (
    <Section>
      <div
        data-v-418ea57b=""
        id="w-node-_97340a72-cd42-bc48-1210-e685fca3d789-0a6b3cff"
        className="col-span-10 col-start-2 py-16 md:pt-0 text-primary-bg-blue"
      >
        <div
          data-v-418ea57b=""
          className="grid gap-4 md:gap-0 grid-cols-[0.75fr_1fr] auto-rows-auto "
        >
          <div
            data-v-418ea57b=""
            id="w-node-_8e19d951-b7f5-e220-64a8-e9c2f9bac30f-0a6b3cff"
            className="col-span-full lg:col-span-1 row-span-1"
          >
            <img
              src={greenHomeOutterRenderPaths.photo1}
              loading="lazy"
              data-nuxt-img=""
              className="h-full w-full object-cover"
              alt="apartment inner view"
            />
          </div>
          <div className="col-span-full lg:col-span-1 flex flex-col gap-[34px] items-start justify-start lg:pl-[10%] py-2">
            <div className="md:text-2xl py-8 lg:py-0 flex flex-col items-start ">
              <p className="tracking-widest font-light">
                მშენებლობა ეკოლოგიურად სუფთა სამშენებლო მასალებით ხდება და
                სრულად ენეგოეფექტურია
                <br />
                <br />
                K2 -ის პრემიუმ საცხოვრებლის მშენებლობისას, გამოყენებულია მხოლოდ
                უმაღლესი ხარისხის მასალა.
                <br />
                <br />
                ხარისხთან ერთად , მოსახერხებელი ლოკაცია და ყოველდღიურ
                საყოფაცხოვრებო ობიექტებთან სიახლოვე იდეალურ კომბინაციას ქმნის
                მობინადრის კომფორტის სრულყოფისთვის.
                <br />
              </p>
            </div>
            <a
              href="/projects/greenhome/block"
              onClick={(event) => {
                delayNavigation(
                  dispatch,
                  navigate,
                  "/projects/greenhome/block",
                  event
                );
              }}
              className="relative group flex flex-col items-center justify-center whitespace-nowrap w-fit cursor-pointer text-lg font-extrabold tracking-[3.36px] leading-[1.2] uppercase "
            >
              იპოვე ბინა
              <span className="absolute bottom-0 left-0 w-0 h-[2px] bg-primary-bg-blue transition-all duration-500 group-hover:w-full"></span>
            </a>
          </div>
        </div>
        <div
          data-v-418ea57b=""
          className="grid grid-cols-[0.75fr_1fr] auto-rows-auto gap-0 "
        >
          <div
            data-v-418ea57b=""
            id="w-node-_87249cc8-ac06-4f42-fc9a-7373f4eb5983-0a6b3cff"
            className="col-span-full md:col-span-1 flex items-center justify-center max-h-max "
          >
            <div
              data-v-418ea57b=""
              id="w-node-e4a8ea3a-2ff3-8b57-f5d9-170348458f83-0a6b3cff"
              className="col-span-full xl:col-span-1 row-span-1 flex flex-col items-start justify-start gap-y-[21px] py-[55px] "
            >
              {ApartmentsTypes.greenhome.apartmentsArray.map((type) => {
                return (
                  <h1
                    key={type.id}
                    data-v-418ea57b=""
                    className={`cursor-${
                      selectedType === type.name ? "default:" : "pointer"
                    } opacity-${selectedType === type.name ? "100" : "50"} ${
                      selectedType === type.name
                        ? "text-primary-bg-blue"
                        : "text-primary-bg-blue/50"
                    } ${
                      selectedType !== type.name ? "hover:opacity-85" : ""
                    } text-lg md:text-4xl font-gilroy tracking-[4.41px] leading-[1.2]  uppercase transform duration-300 ease-linear`}
                    onClick={() => setSelectedType(type.name)}
                  >
                    {type.label}
                  </h1>
                );
              })}
            </div>
          </div>
          <div
            data-v-418ea57b=""
            id="w-node-_9b5e9182-6309-5372-cb86-bd0a2b05bc29-0a6b3cff"
            className="col-span-full xl:col-span-1 row-span-1 h-[350px] md:h-[750px] relative transform transition-all animate-fadeIn"
          >
            {/* კვადრატულობის წარწერის დივი */}

            <div
              data-v-418ea57b=""
              className="absolute left-12 top-12 md:left-16 md:top-14 flex items-start justify-start text-primary-bg-blue"
            >
              <div
                data-v-418ea57b=""
                className="flex items-center justify-start uppercase text-lg md:text-3xl tracking-widest"
              >
                <div data-v-418ea57b="">
                  <h2>
                    <strong>
                      {selectedTypeObj.subType[0].size} -{" "}
                      {
                        selectedTypeObj.subType[
                          selectedTypeObj.subType.length - 1
                        ].size
                      }
                    </strong>
                  </h2>
                </div>
                <h1 data-v-418ea57b="">
                  m<sup data-v-418ea57b="">2</sup>
                </h1>
              </div>
              <p
                data-v-418ea57b=""
                to="/ka/null"
                className="noUnderline link link hide-tablet"
              ></p>
            </div>
            {/* სურათის დივი */}
            <div data-v-418ea57b="" className="w-full h-full p-8 rounded-3xl">
              <img
                data-v-418ea57b=""
                src={selectedTypeObj.img}
                loading="lazy"
                data-nuxt-img=""
                className="h-5/6 w-full object-cover animate-fadeIn rounded-3xl"
                alt="apartments"
              />
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default ApartmentsSection;
